@if (message) {
  <div class="alert animate__animated" (click)="animation='close'" [class.lightMode]="$safeNavigationMigration(user?.color)|isLight"
    [class.animate__fadeOutLeft]="animation=='close'" [class.animate__rotateIn]="animation=='start'"
    [class.animate__bounceOutDown]="animation=='end'"
    [style.background]="'linear-gradient(45deg, '+user?.color+', '+user?.color+'b8)'"
    [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }">
    {{ message.text }}
  </div>
}